import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 */
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const JourneySection = lazy(() => import('./components/JourneySection').then(m => ({
  default: m.JourneySection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const PositioningSection = lazy(() => import('./components/PositioningSection').then(m => ({
  default: m.PositioningSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const CoverageSection = lazy(() => import('./components/CoverageSection').then(m => ({
  default: m.CoverageSection
})));
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const AudienceSection = lazy(() => import('./components/AudienceSection').then(m => ({
  default: m.AudienceSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-cream'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="d2bh5dik1ru3" />} data-id="element-0" data-mp="d3wc348s7csh">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-cream text-charcoal" data-id="element-2" data-mp="3gm647qcpav3v">
      <Hero data-id="element-3" data-mp="3bmbalf1jjrf4" />
      <Deferred minHeight="620px" data-id="element-4" data-mp="3bmtij8xkfu2v">
        <PainSection data-id="element-5" data-mp="3bnuurgqbimm6" />
      </Deferred>
      <Deferred minHeight="760px" background="bg-sand" data-id="element-6" data-mp="3qb7j1d7if6g9">
        <JourneySection data-id="element-7" data-mp="3qbzcoihjqu3w" />
      </Deferred>
      <Deferred minHeight="640px" background="bg-charcoal" data-id="element-8" data-mp="3lkheu3atl9n5">
        <MethodSection data-id="element-9" data-mp="3liwkoesf3spt" />
      </Deferred>
      <Deferred minHeight="1100px" data-id="element-10" data-mp="2xuwsdafgju94">
        <TomosSection data-id="element-11" data-mp="2xtv6eawwlncm" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-sand" data-id="element-12" data-mp="2xsseq0rrbgvn">
        <PositioningSection data-id="element-13" data-mp="2suqyropmnxoe" />
      </Deferred>
      <Deferred minHeight="880px" data-id="element-14" data-mp="2stpjf81kwp0v">
        <BonosSection data-id="element-15" data-mp="18d9d06h7bks6" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-sand" data-id="element-16" data-mp="18c6qsbutq6il">
        <CoverageSection data-id="element-17" data-mp="1d4ztyvan96sk" />
      </Deferred>
      <Deferred minHeight="560px" data-id="element-18" data-mp="1d62l94bvpb90">
        <TransformationSection data-id="element-19" data-mp="yflkln72ipd6" />
      </Deferred>
      <Deferred minHeight="620px" background="bg-sand" data-id="element-20" data-mp="ygwjb8lnp6xf">
        <BenefitsSection data-id="element-21" data-mp="13eevr8yvu4a6" />
      </Deferred>
      <Deferred minHeight="620px" data-id="element-22" data-mp="13fg61b82qmqu">
        <AudienceSection data-id="element-23" data-mp="13cbvzx7xgws9" />
      </Deferred>
      <Deferred minHeight="720px" background="bg-sand" data-id="element-24" data-mp="1r3zdxpn7oxie">
        <OfferSection data-id="element-25" data-mp="1r2g2ccci3amy" />
      </Deferred>
      <Deferred minHeight="520px" data-id="element-26" data-mp="1w3lrk06ycfrq">
        <FaqSection data-id="element-27" data-mp="1w2khnz1o9zbl" />
      </Deferred>
      <Deferred minHeight="480px" background="bg-charcoal" data-id="element-28" data-mp="1i3uk6iaxxxmp">
        <FinalCta data-id="element-29" data-mp="1i3b4z9codncd" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-sand" data-id="element-30" data-mp="1m4wag9mvqzcj">
        <Footer data-id="element-31" data-mp="1m3cu6j184oar" />
      </Deferred>
      <Suspense fallback={null} data-id="element-32" data-mp="6ofe8p0r7vfg">
        <StickyBuyBar data-id="element-33" data-mp="6nco4jb99x0l" />
      </Suspense>
    </main>;
}